var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtherOrganization(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 138,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M16.241 62.373c6.94 9.525 12.835 22.174 8.213 33.16-2.45 5.827-8.137 10.83-7.825 17.684.332 7.201 6.497 11.773 12.492 13.746 4.868 1.595 9.852.892 14.812 1.844 7.61 1.46 20.221-5.86 28.063-5.205 10.2.02 18.678 7.505 32.026 3.361 13.347-4.144 15.554-8.182 25.708-19.948 7.031-3.922 31.753-6.215 26.559-16.248-5.195-10.034-16.404-12.887-22.653-21.852-13.279-8.404 16.404-29.442-6.249-43.702-19.58-12.326-27.974.393-35.15 5.603-10.138 7.37-18.6 19.977-30.438 16.41-7.08-2.13-12.98-9.731-19.997-12.07-8.121-2.709-17.44-1.05-24.263 4.317-3.741 2.945-6.895 7.45-6.507 12.35.322 4.007 2.887 7.356 5.21 10.55z",
    fill: "#2D9BDB",
    fillOpacity: 0.15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#otherOrganization_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.437 89.893a3.59 3.59 0 01-3.59 3.59H42.133a3.59 3.59 0 01-3.591-3.59c0-9.04 7.325-16.407 16.406-16.407h10.082c9.08 0 16.406 7.367 16.406 16.407z",
    fill: "#D2D2D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.437 89.893a3.59 3.59 0 01-3.591 3.59H45.472a3.59 3.59 0 01-3.59-3.59c0-9.04 7.324-16.407 16.406-16.407h6.742c9.081 0 16.407 7.367 16.407 16.407z",
    fill: "#EBEBF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.982 73.468l-3.992 6.775-3.992-6.775V63.78h7.984v9.69z",
    fill: "#83603F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.179 86.43v7.053h-1.67V86.43a.835.835 0 011.67 0zM73.472 86.43v7.053h-1.67V86.43a.834.834 0 011.67 0z",
    fill: "#D2D2D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.034 86.657H58.02l-2.114 6.826h8.31l-2.183-6.826z",
    fill: "#6990D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.808 86.827h-3.635a1.34 1.34 0 01-1.336-1.335v-3.218c0-.734.6-1.335 1.336-1.335h3.635c.734 0 1.335.601 1.335 1.336v3.217c0 .734-.6 1.335-1.335 1.335z",
    fill: "#91AEE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.162 57.455a4.665 4.665 0 11-9.33 0 4.665 4.665 0 019.33 0zM76.52 57.456a4.665 4.665 0 11-9.33 0 4.665 4.665 0 019.33 0z",
    fill: "#83603F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.305 39.086v21.693c0 5.641-6.603 10.383-10.516 11.74-.735.254-1.374.389-1.858.389-1.534 0-4.627-1.358-7.336-3.553-2.711-2.195-5.038-5.227-5.038-8.576V39.086a4.003 4.003 0 014.003-4.003H68.3a4.003 4.003 0 014.005 4.003z",
    fill: "#83603F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.304 39.086v21.693c0 4.88-4.943 9.089-8.811 11.013a3.818 3.818 0 01-3.4.005 20.863 20.863 0 01-3.784-2.442c-2.71-2.195-5.037-5.227-5.037-8.576V39.086a4.003 4.003 0 014.003-4.003h13.026a4.003 4.003 0 014.003 4.003z",
    fill: "#A07A56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.55 33.236v1.244c0 5.03-10.064 14.895-23.366 14.81h-2.296c-1.29 0-2.338-.723-2.338-1.614V37.61c0-2.79 3.287-5.052 7.338-5.052h19.677c.147 0 .288.022.414.063.336.108.57.343.57.617z",
    fill: "#54342A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.979 32.62c-2.303 5.242-11.35 12.532-22.795 12.459h-2.296c-1.29 0-2.338-.723-2.338-1.614V37.61c0-2.79 3.287-5.052 7.338-5.052h19.677c.147 0 .288.022.414.063z",
    fill: "#6A4B41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.027 70.876l-3.062 3.195a.97.97 0 00-.225.966l2.78 8.758c.42.768 1.5 1.012 2.268.513l5.491-3.556-5.713-9.697a.973.973 0 00-1.539-.18z",
    fill: "#AEC2E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.953 70.876l3.063 3.195a.97.97 0 01.224.966l-2.78 8.758c-.42.768-1.499 1.012-2.268.513l-5.49-3.556 5.712-9.697a.973.973 0 011.54-.18z",
    fill: "#AEC2E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.81 59.74s-.12 5.61-6.252 10.035a.38.38 0 00-.114.493c.611 1.104 3.119 4.886 9.194 5.724 0 0 25.449-.163 25.449 0 6.076-.838 8.584-4.62 9.194-5.723a.38.38 0 00-.113-.493c-4.177-3.015-5.565-7.82-6.023-10.036H92.81z",
    fill: "#F29500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.867 66.828h12.091v20.666h-12.091V66.828zM99.54 57.963a4.68 4.68 0 11-9.36 0 4.68 4.68 0 019.36 0zM124.946 57.963a4.68 4.68 0 11-9.361 0 4.68 4.68 0 119.361 0z",
    fill: "#F2BB88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.533 39.532v21.766c0 3.36-2.335 6.403-5.055 8.605-1.869 1.512-3.917 2.629-5.516 3.18-.728.251-1.364.385-1.845.385-3.077-.001-12.416-5.45-12.416-12.17V39.532a4.017 4.017 0 014.018-4.017h16.796a4.018 4.018 0 014.018 4.017z",
    fill: "#F2BB88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.532 39.532v21.766c0 3.36-2.334 6.403-5.054 8.605-1.869 1.512-3.917 2.629-5.516 3.18-3.926-1.353-10.57-6.116-10.57-11.785V39.532a4.018 4.018 0 014.017-4.017h13.106a4.017 4.017 0 014.017 4.017z",
    fill: "#F2D1A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.836 46.99c.338-.91 1.61-.952 2.006-.066l1.255 2.809a5.657 5.657 0 005.165 3.349c.692 0 1.253-.587 1.253-1.311v-8.417c0-5.657-4.464-10.079-9.744-10.079h-10.818c-5.22 0-9.59 4.307-9.738 9.776-.008.307-.004 22.63-.004 22.608a1.886 1.886 0 003.773 0V54.827c0-.85.842-1.443 1.642-1.156a12.198 12.198 0 0012.33-2.466l.095-.087a10.54 10.54 0 002.785-4.128z",
    fill: "#FFA90B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.148 85.26v6.415a1.993 1.993 0 01-1.993 1.993H91.57c-1.101 0-1.995-.891-1.995-1.993V85.26c0-5.181 3.97-9.44 9.031-9.897.3-.028.602-.042.908-.042h3.11c.088 0 .173-.01.257-.026l.021.03.098.148 3.798 5.72a2.2 2.2 0 003.583.118l4.579-5.99h2.248c.321 0 .635.017.944.046 5.049.474 8.996 4.723 8.996 9.893z",
    fill: "#2E5AAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.148 85.26v6.415a1.993 1.993 0 01-1.993 1.993H95.26a1.993 1.993 0 01-1.993-1.993v-6.416c0-5.181 3.968-9.44 9.031-9.897.2-.018.402-.032.605-.038l.098.148 3.797 5.719a2.201 2.201 0 003.584.119l4.579-5.99h2.248a9.936 9.936 0 019.939 9.94z",
    fill: "#4172CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.515 43.354v5.123c-2.512-.424-4.677-1.926-5.744-4.074l-1.747-3.517c-.552-1.11-2.324-1.058-2.793.08-.816 1.978-2.145 3.75-3.878 5.171l-.133.11c-3.179 2.604-7.277 3.982-11.441 3.982-1.528 0-3.065-.187-4.57-.564 0-6.82-.005-6.25.005-6.615.15-5.467 4.518-9.774 9.739-9.774h10.818c5.279 0 9.744 4.422 9.744 10.078z",
    fill: "#FFB52D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.102 98.424v26.304a1.55 1.55 0 01-1.55 1.55H41.447a1.55 1.55 0 01-1.55-1.55V98.424h89.205z",
    fill: "#C0694E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.102 118.859v5.869a1.55 1.55 0 01-1.55 1.55H41.447a1.55 1.55 0 01-1.55-1.55v-5.832h89.002l.203-.037z",
    fill: "#AE583E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132 96.2v4.449a2.741 2.741 0 01-2.741 2.742H39.741A2.741 2.741 0 0137 100.649v-4.448a2.74 2.74 0 012.741-2.741h89.518A2.74 2.74 0 01132 96.2z",
    fill: "#C97E67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132 96.2v.266H46.955a2.74 2.74 0 01-2.741-2.741v-.265h85.045A2.74 2.74 0 01132 96.2z",
    fill: "#DBA999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "otherOrganization_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(37 32)",
    d: "M0 0h95v95H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/otherOrganization.bf16f5b6.svg";
export { SvgOtherOrganization as ReactComponent };